import styled from '@emotion/styled';
import { COLORS } from '../../constants';

export const StyledWritingProforma = styled.div`
  margin: 0 auto;
  width: 926px;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
  font-family: Mulish;
  background: ${COLORS.blackOlive};
`;

export const StyledWritingSection = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  margin-bottom: 10px;

  width: 458px;
`;

export const StyledProformaSectionHeader = styled.div<{ bGColor: string }>`
  padding: 5px 14px;
  background: ${({ bGColor }) => bGColor};
  display: flex;
  font-family: Lexend;
  font-size: 16px;
  font-weight: 600;
`;

export const StyledTextAreaWrapper = styled.div<{ bGColor: string }>`
  padding: 10px;
  background: ${({ bGColor }) => bGColor};
`;

export const StyledTextArea = styled.textarea`
  border-radius: 4px;
  border: solid 1px #d9d9d9;
  background-color: ${COLORS.white};
  resize: none;
  padding: 5px;
  font-family: Mulish;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.36;
  letter-spacing: 0.28px;
  text-align: left;

  width: 100%;
`;

export const StyledProformaImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 218px;

  background: ${COLORS.white};

  div > img {
    height: 218px;
    padding: 10px;
    border-radius: 20px;
    object-fit: cover;
  }
`;

export const StyledProformaLanguagesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const StyledProformaControlsWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
`;
